// extracted by mini-css-extract-plugin
export default {"marker":"Marker_marker__1HrZj","popup":"Marker_popup__svPBX"};